import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('token') || null,
  asha_id: localStorage.getItem('asha_id') || null,
  phoneNumber: localStorage.getItem('user') || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.token = action.payload.token;
      state.asha_id = action.payload.asha_id;
      state.phoneNumber = action.payload.phoneNumber;
    },
    logout: (state) => {
      state.token = null;
      state.asha_id = null;
      state.phoneNumber = null;
      localStorage.clear();
    }
  },
});

export const { setAuth, logout } = authSlice.actions;
export default authSlice.reducer;
  